import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';

export const HEADER_HEIGHT_PX = `${gridSize * 20}px`;
